import {Component, OnInit} from '@angular/core';
import {AuthorisedSideNavService} from '../services/authorised-side-nav.service';

@Component({
    selector: 'app-authorised-layout',
    templateUrl: './authorised-layout.component.html',
    styleUrls: ['./authorised-layout.component.css']
})
export class AuthorisedLayoutComponent implements OnInit {

    constructor(private sideNavService: AuthorisedSideNavService) {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/layout/authorised/authorised-layout/authorised-layout.component.ts